module.exports = __webpack_public_path__ + "fonts/fa-solid-900.8547525.woff2";